// extracted by mini-css-extract-plugin
export var component = "HelpMenu-module--component--qFF0P";
export var item = "HelpMenu-module--item--XWomb";
export var link = "HelpMenu-module--link--MnnZd";
export var list = "HelpMenu-module--list--awTBb";